import React from 'react'
import PropTypes from 'prop-types'
import { ListItemStyled, StyledLink, StyledEditWrapper } from './styled'
import Icon from '../Icon'

const ListItem = ({ children, item, active, to, bordercolor, arrow, pointer, isEditMode, editContent, onClick }) => (
    <ListItemStyled active={active ? 1 : 0} bordercolor={bordercolor} pointer={pointer} onClick={onClick}>
        {
            editContent &&
            <StyledEditWrapper pose={isEditMode ? 'visible' : 'hidden'}>
                {editContent(item)}
            </StyledEditWrapper>
        }
        {children}
        {
            arrow &&
            <Icon name="arrow" pose={isEditMode ? 'hidden' : 'visible'} />
        }
        {
            to &&
            <StyledLink to={to} onClick={e => isEditMode ? e.preventDefault() : e.persist()} hidden={isEditMode} />
        }
    </ListItemStyled>
)

ListItem.propTypes = {
    to: PropTypes.object,
    active: PropTypes.bool,
    arrow: PropTypes.bool,
    pointer: PropTypes.bool,
    isEditMode: PropTypes.bool,
    onClick: PropTypes.func
};

ListItem.defaultProps = {
    to: null,
    active: true,
    arrow: true,
    pointer: true,
    isEditMode: false,
    onClick: () => { }
};

export default ListItem
